import { render } from "./OverviewWeeklyStatistics.vue?vue&type=template&id=45278c33"
import script from "./OverviewWeeklyStatistics.vue?vue&type=script&lang=js"
export * from "./OverviewWeeklyStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__